import { memo } from 'react';

import type { IncidentType } from '@/types';

import { useIncidentTiming } from '@/hooks/use-incident-timing';
import { cn } from '@/lib/utils';

interface IncidentTimingProps {
  periods: IncidentType['activePeriod'];
  isListItem?: boolean;
}

const IncidentTiming = ({ periods, isListItem }: IncidentTimingProps) => {
  const { groupedPeriods } = useIncidentTiming(periods, isListItem);

  if (!groupedPeriods.length) {
    return null;
  }

  return (
    <div className="flex flex-col gap-1">
      {groupedPeriods.map(({ formattedPeriod }) => (
        <div key={formattedPeriod} className="flex flex-col">
          {formattedPeriod.split('\n').map((line) => (
            <time
              key={line}
              className={cn('text-xs font-semibold text-primary', {
                'text-foreground font-medium': isListItem,
              })}
            >
              {line}
            </time>
          ))}
        </div>
      ))}
    </div>
  );
};

export default memo(IncidentTiming);
